export const LEFT_DRAWER_Z_INDEX = 1070;
export const ZENDESK_URL = 'https://go-game.zendesk.com/hc/en-us/requests/new';
